import get from 'lodash/get';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';

import * as BackstageConstants from '../../../constants';
import * as D from '../../../deps';
import BackstagePlayableRowGrid from '../../BackstagePlayableRowGrid';
import BackstagePlayableRowItem from '../../BackstagePlayableRowItem';

const ArtistTopSongs = props => {
  const { integration } = useContext(D.AppContext);

  const contentSection = BackstageConstants.BackstageSections.TOP_SONGS;
  const integrationData = { contentSection };

  const onSeeAllSongsClick = e => {
    integration.action.clicked({
      ...integrationData,
      destinationUrl: e.currentTarget.pathname,
    });
  };

  const moreUrl = props.shareableUrlPath
    ? D.getBackstageArtistAllSongsPathForShareUrl(props.shareableUrlPath)
    : null;

  const numTracksToRender = !props.isMobileWeb
    ? BackstageConstants.BackstageConstants.NUM_TOP_TRACKS_TO_RENDER
    : BackstageConstants.BackstageConstants.NUM_ITEMS_TO_RENDER_MOBILE_WEB;
  return (
    <BackstagePlayableRowGrid
      contentSection={contentSection}
      title={<FormattedMessage {...BackstageConstants.messages.topSongs} />}
      onSeeAllClick={onSeeAllSongsClick}
      moreUrl={moreUrl}
      moreText={<FormattedMessage {...BackstageConstants.messages.viewAll} />}
    >
      {props.topTracks.slice(0, numTracksToRender).map((track, index) => {
        const pandoraId = get(track, 'pandoraId', '');
        return (
          <BackstagePlayableRowItem
            key={pandoraId || index}
            pandoraId={pandoraId}
            playIndex={index}
            playablePandoraId={props.artistPlayId}
            pandoraType={D.PandoraTypes.SONG}
            imgUrl={get(track, 'icon.artUrl', '')}
            itemName={get(track, 'name', '')}
            itemUrl={get(track, 'shareableUrlPath', '')}
            trackDuration={D.formatTime(get(track, 'duration', null))}
            secondText={get(track, 'albumName.name')}
            secondTextUrl={get(track, 'album.urlPath')}
            isExplicit={
              get(track, 'explicitness', null) ===
              D.getInDomain('catalog.constants.Explicitness.EXPLICIT')
            }
            isClean={
              get(track, 'explicitness', null) ===
              D.getInDomain('catalog.constants.Explicitness.CLEAN')
            }
            isUnavailable={
              !get(track, 'rights.hasInteractive', false) &&
              !get(track, 'rights.hasRadioRights', true)
            }
            isRadioOnly={
              !get(track, 'rights.hasInteractive', false) &&
              get(track, 'rights.hasRadioRights', false)
            }
            hasBorderTopBottom={true}
            showAlbumName={true}
          />
        );
      })}
    </BackstagePlayableRowGrid>
  );
};

const ArtistTopSongsWithLogger = D.withVisibilityLogger({
  contentSection: BackstageConstants.BackstageSections.TOP_SONGS,
})(ArtistTopSongs);

ArtistTopSongs.propTypes = {
  artistPlayId: PropTypes.string,
  topTracks: PropTypes.array,
  shareableUrlPath: PropTypes.string,
  isMobileWeb: PropTypes.bool,
};

export default ArtistTopSongsWithLogger;
